module.exports = __webpack_public_path__ + "media/customizations/collective/logo-2eb940f3406eea61eb8322d27e6f0c12.png";